export default (state = {
    keyword: "",
    categories: [],
    category: [],
    products: [],
    fetchingCategories: false,
    fetchingProducts: false,
    has_more: true,
    is_loading: true,
    pagination: {
        page:1,
        pages:1,
        total:0,
        count:0
    }

}, action) => {
    switch (action.type) {
        case 'UPDATE_PRODUCT_SEARCH_KEYWORD' :
            return {
                ...state,
                keyword: action.keyword,
                products: [],
                has_more: false,
                is_loading: false,
            };

        case 'FETCHING_PRODUCT_SEARCH_CATEGORY' :
            return {
                ...state,
                fetchingCategories: false,
                products: [],
                has_more: false,
                is_loading: false,
            };
        case 'FETCHING_PRODUCT_SEARCH_CATEGORY_FAILED' :
            return {
                ...state,
                fetchingCategories: 0,
                has_more: false,
                is_loading: false,
            };
        case 'FETCH_PRODUCT_SEARCH_CATEGORY' :
            return {
                ...state,
                categories: action.results,
                fetchingCategories: true,
                has_more: false,
                is_loading: false,
            };

        case 'FETCH_PRODUCT_RESET_PRODUCTS_SEARCH' :
            return {
                ...state,
                products: [],
                pagination: {
                    count: 0,
                    scroll_id: '',
                }
            };
        case 'FETCHING_PRODUCT_SEARCH' :
            return {
                ...state,
                fetchingProducts: true,
                is_loading: true,

            };
        case 'FETCHING_PRODUCT_SEARCH_FAILED' :
            return {
                ...state,
                fetchingProducts: 0,
            };
        case 'FETCH_PRODUCT_SEARCH' :
            return {
                ...state,
                products: action.results.pagination.page === 1?action.results.results:state.products.concat(action.results.results),
                category: action.results.category[0] || [],
                fetchingProducts: true,
                has_more: (action.results.pagination.pages > action.results.pagination.page),
                is_loading: false,
                pagination: action.results.pagination
            };
        default:
            return state;
    }
};
